import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RouteHelper} from "../../route/RouteHelper";
import {
    RaikoDefaultDialogPage,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoTableTitleContainer,
    RaikoCustomTable,
    RaikoBaseContainer,
    showErrorMessage,
    RaikoCustomSimpleActiveDeActiveChip
} from '@moeindal/base-raiko-panel-components'
import {VersionControlService} from "../../serverService/versionControl/VersionControlService";
import {addNewRowToTable} from "../../util/TableProvider";
import VersionControlAddDetail from "./VersionControlAddDetail";


export default function VersionControl() {

    let page = 0
    const size = 20

    const [totalItems, setTotalItems] = useState("")
    const [apkFiles, setApkFiles] = useState([]);
    const [tableLoading, setTableLoading] = useState(false)
    const [pageCount, setPageCount] = useState(0);

    const navigate = useNavigate()

    const service = new VersionControlService()

    useEffect(() => {
        getDataFromServer()
    }, []);


    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getVersions(
            page, size
        ).then(response => {
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            setApkFiles([])
            response.data.map((item, index) => {
                setApkFiles(prev => [
                    ...prev,
                    prepareSliderItem(
                        item.id,
                        (page * size) + index + 1,
                        item.title,
                        item.versionNumber,
                        item.latestVersionForMandatoryUpdate,
                        item.mandatory,
                        item.enabled,
                    )
                ])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function prepareSliderItem(id, number, title, version, minVersion, updateType, type) {
        return {
            id,
            number,
            title,
            version: version,
            "min-version": minVersion,
            "update-type": <RaikoCustomSimpleActiveDeActiveChip
                state={!updateType}
                deActiveStateTitle={"اجباری"}
                activeStateTitle={"اختیاری"}
            />,
            type: <RaikoCustomSimpleActiveDeActiveChip
                state={type}
                deActiveStateTitle={"غیرفعال"}
                activeStateTitle={"فعال"}
            />
        }
    }

    function handleSelectRow(_item) {
        /*let _title = ""
        apkFiles.map((item) => {
            if (item.id === _item)
                _title = item.name
        })

        navigate(
            RouteHelper.MagazineChartDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )*/
        setVersionControlId(_item)
        handleOpenDialog()
    }

    const [versionControlId, setVersionControlId] = useState(-1);

    const [openDialog, setOpenDialog] = useState(false)

    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => {
        setVersionControlId(-1)
        setOpenDialog(false)
    }

    function handleAddNewVersion(item) {
        const newItems = addNewRowToTable(
            prepareSliderItem(
                item.id,
                1,
                item.title,
                item.versionNumber,
                item.latestVersionForMandatoryUpdate,
                item.mandatory,
                item.enabled,
            ),
            apkFiles
        )

        setApkFiles(newItems)
        handleCloseDialog()

    }

    function handleUpdateVersion(item) {
        const items = []

        apkFiles.map((_item, index) => {
            if (_item.id === item.id) {
                items.push({
                    ...prepareSliderItem(
                        item.id,
                        _item.number,
                        item.title,
                        item.versionNumber,
                        item.latestVersionForMandatoryUpdate,
                        item.mandatory,
                        item.enabled,
                    )
                })
            } else {
                items.push(_item)
            }
        })

        setApkFiles(items)
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openDialog}
                pageTitle={"افزودن نسخه جدید"}
            >
                <VersionControlAddDetail
                    versionControlId={versionControlId}
                    handleAddNewVersion={handleAddNewVersion}
                    handleUpdateVersion={handleUpdateVersion}
                />
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.VersionControl.name,
                        ""
                    )
                ]}/>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"نسخه ها"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={apkFiles}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>
        </>
    )
}

const header = [
    {
        id: "number",
        label: "#"
    },
    {
        id: "title",
        label: "نام"
    },
    {
        id: "version",
        label: "ورژن"
    },
    {
        id: "min-version",
        label: "حداقل ورژن مجاز"
    },
    {
        id: "update-type",
        label: "حداقل ورژن مجاز"
    },
    {
        id: "type",
        label: "وضعیت"
    },
]
